import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 4,
	height: 4,
	viewBox: "0 0 4 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		x: .511963,
		y: .523926,
		width: 3,
		height: 3,
		rx: 1.5,
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgDot);
export default ForwardRef;
